import { render, staticRenderFns } from "./VerifyMessageInput.vue?vue&type=template&id=5ef87dc7&scoped=true&"
import script from "./VerifyMessageInput.vue?vue&type=script&lang=js&"
export * from "./VerifyMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./VerifyMessageInput.vue?vue&type=style&index=0&id=5ef87dc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef87dc7",
  null
  
)

export default component.exports